<app-spinner [show]="showSpinner"></app-spinner>
<!-- Start Page Title Area -->
<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">{{home}}</a></li>
                <li><a href="javscript:;">{{coursesText}}</a></li>
            </ul>
            <h2>{{checkout}}</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Checkout Area -->
<section class="checkout-area ptb-100">
    <div class="container">


        <form>
            <div class="row">

                <div class="col-lg-12 col-md-12">
                    <div class="order-details">

                        <div class="payment-box">
                            <h3 class="title">{{yourOrder}}</h3>
                            <div class="order-table table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">Price</th>
                                            <th *ngIf="coupon">Price (After Discount)</th>
                                            <th scope="col">Duration</th>
                                            <th scope="col">Course Name</th>
                                            <th>Image</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr>
                                            <td class="product-total">
                                                <span [ngClass]="setClassesLabel()">${{course.getShowPrice()}}</span>
                                            </td>
                                            <td *ngIf="coupon" class="product-total">
                                                <span class="discount-price">${{getDiscountPrice()}}</span>
                                            </td>
                                            <td class="product-total">
                                                <span>{{course.length}}</span>
                                            </td>
                                            <td class="product-name">
                                                <a href="#">{{course.name}}</a>
                                            </td>
                                            <td>
                                                <img *ngIf="course.image" width="60" src="{{course.image.fileUrl}}"
                                                    alt="">
                                            </td>




                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>

                        <div class="payment-box">
                            <h3 class="title">Coupon</h3>
                            <div class="row align-items-center">
                                <div class="col-lg-8 col-md-8">
                                    <!-- <input id="coupon-box" type="text" placeholder="Coupon Code" ngModel #couponCode="ngModel"> 
                                     <button id="btn-apply" (click)="onApplyCouponCode(couponCode.value)">Apply</button> -->
                                    <div class="input-group">
                                        <input type="text" [ngClass]="setClassesInput()" placeholder="Coupon Code"
                                            aria-label="Recipient's username" aria-describedby="basic-addon2"
                                            [(ngModel)]="couponCode">
                                        <div class="input-group-append">
                                            <button id="btn-remove" *ngIf="coupon" class="btn btn-outline-secondary"
                                                type="button" (click)="onRemoveCoupon()">Remove</button>
                                            <button id="btn-apply" *ngIf="!coupon" class="btn btn-outline-secondary"
                                                type="button" (click)="onApplyCouponCode()">Apply</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div id="payment-div" class="payment-box">

                            <app-slide-panel [activePane]="isLeftVisible ? 'left' : 'right'">
                                <div leftPane>
                                    <div class="main-container">
                                        <h3 class="title">{{choosePaymentMethod}}</h3>
                                        <div class="payment-method">
                                            <p class="bank-panel" *ngFor="let bank of banks">
                                                <input (change)="onChoosePaymentMethod(bank)" type="radio"
                                                    id="{{bank.id}}" name="radio-group">
                                                <label for="{{bank.id}}">{{translate(bank.nameEn,bank.nameKh)}}</label>
                                            </p>
                                        </div>
                                        <a id="next-btn-mobile" (click)="onNext(tid.value)" href="javascript:;"
                                            [ngClass]="setClasses(tid.value)"><span class="label">
                                                {{nextButtonTitle}}</span></a>
                                    </div>

                                </div>
                                <div rightPane>
                                    <h3 class="title">{{transferMoney}}</h3>
                                    <div class="row main-container">
                                        <div class="col-lg-6 col-md-12">
                                            <div id="qr_div" *ngIf="selectedBank.qrImageUrl != '' ">
                                                <h5>{{scanToPay}}</h5>
                                                <img src="{{selectedBank.qrImageUrl}}" alt="">
                                            </div>
                                            <h3>{{selectedBank.nameEn}}</h3>
                                            <p style="margin-top:15px;">
                                                <span>Account Name :</span> <strong>
                                                    {{selectedBank.accountName}}</strong>
                                            </p>
                                            <p>
                                                <span>Account No :</span> <strong> {{selectedBank.accountNo}}</strong>
                                            </p>


                                            <form id="form-tid" #it="ngForm" (ngSubmit)="onNext(tid.value)" novalidate>
                                                <p>
                                                    <input placeholder="{{enterTID}}" class="form-control" name="tid"
                                                        ngModel required #tid="ngModel">
                                                    <span style="font-size:13px">{{transferRemark}}</span>
                                                </p>
                                            </form>

                                            <fieldset>
                                                <legend>Upload screenshot</legend>
                                                <app-image-uploader (onChooseFile)="onChooseFile($event)">
                                                </app-image-uploader>
                                            </fieldset>


                                        </div>
                                        <div id="desc-container" class="col-lg-6 col-md-12">
                                            <h5>{{privacyTitle}}</h5>
                                            <p>{{privacyDesc}}</p>
                                        </div>
                                    </div>
                                </div>

                            </app-slide-panel>
                            <div class=" clearfix">

                                <a *ngIf="isLeftVisible && !isMobile()" (click)="onNext(tid.value)" href="javascript:;"
                                    [ngClass]="setClasses(tid.value)"><span class="label">
                                        {{nextButtonTitle}}</span></a>

                                <a *ngIf="!isLeftVisible" (click)="onNext(tid.value)" href="javascript:;"
                                    [ngClass]="setClasses(tid.value)"><span class="label">
                                        {{submit}}</span></a>
                                <a *ngIf="!isLeftVisible" style="margin-right:10px;" (click)="onBack()"
                                    href="javascript:;" class="app-btn float-right gray-bg"><span class="label">
                                        {{back}}</span></a>


                            </div>

                        </div>



                    </div>
                </div>
            </div>
        </form>
    </div>
</section>
<!-- End Checkout Area -->